import { Controller } from "@hotwired/stimulus"

// Handles exporting selected items from a table with checkboxes
// Works with BulletTrain's bulk-actions checkbox system
export default class extends Controller {
  static values = { url: String }

  export() {
    // Get all checked checkboxes using BulletTrain's bulk-actions target
    const checkboxes = document.querySelectorAll('[data-bulk-actions-target="checkbox"]:checked')
    const ids = Array.from(checkboxes).map(cb => cb.value)

    if (ids.length === 0) {
      alert('Please select at least one item to export. Click "Select Multiple" first, then check the items you want to export.')
      return
    }

    // Create a form and submit it to trigger the CSV download
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = this.urlValue

    // Add CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (csrfToken) {
      const csrfInput = document.createElement('input')
      csrfInput.type = 'hidden'
      csrfInput.name = 'authenticity_token'
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
    }

    // Add selected IDs
    ids.forEach(id => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'ids[]'
      input.value = id
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
  }
}
